// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"787aa4a5","732":"5635e074","977":"339668bb"}[chunkId] + ".chunk.js";
};